import {Box, Typography} from '@mui/material';
import React, {useId} from 'react';
import ArrCheckbox from '../../../common/arr-checkbox/ArrCheckbox';

interface LabelCheckboxProps {
  label: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  ariaChecked?: 'true' | 'false';
  'aria-label'?: string;
}
const LabelCheckbox: React.FC<LabelCheckboxProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  ariaChecked,
  'aria-label': ariaLabel,
  ...rest
}) => {
  const labelId = useId();
  return (
    <Box sx={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
      <ArrCheckbox
        label=""
        checked={checked}
        size="medium"
        onChange={() => onChange()}
        disabled={disabled}
        inputProps={{
          'aria-labelledby': labelId,
          'aria-checked': ariaChecked,
        }}
        aria-label={label}
        {...rest}
      />
      <Typography
        id={labelId}
        sx={{
          color: disabled ? 'var(--arr-text-inactive, #727882)' : 'inherit',
          userSelect: 'none',
        }}
        data-testid={`label-checkbox-label-${ariaLabel?.replaceAll(' ', '-')}`}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default LabelCheckbox;
